import { EmailLoginResponse } from "@/auth/models/EmailLoginViewModel";
import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { Divider, styled, Typography } from "@mui/material";
import { EmailLogin } from "@/auth/actions/EmailLogin";
import { useAuthSearchParams } from "./useAuthSearchParams";
import { useCountdown } from "usehooks-ts";

const TypographyLink = styled(Typography)({
  cursor: "pointer",
  textDecoration: "underline",
  color: "black",
});

export default function EmailLoginForm({
  emailOrUsername,
}: {
  emailOrUsername: string;
}) {
  const [response, setResponse] = useState<EmailLoginResponse | null>(null);
  const { returnUrl } = useAuthSearchParams();
  const [count, { startCountdown, resetCountdown }] = useCountdown({
    countStart: 30,
    intervalMs: 1000,
  });
  const handleEmailLogin = useCallback(async () => {
    resetCountdown();
    startCountdown();
    const response = await EmailLogin({
      emailOrUsername,
      returnUrl,
    });
    setResponse(response);
  }, [emailOrUsername, returnUrl, resetCountdown, startCountdown]);

  useEffect(() => {
    handleEmailLogin();
  }, [handleEmailLogin]);

  return (
    <Box>
      <Box
        sx={{
          padding: 4,
          display: "flex",
          flexDirection: "column",
          gap: 8,
          width: "100%",
          backgroundColor: "white",
          alignItems: "center",
          borderRadius: 5,
        }}
      >
        {response?.emailSent ? (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                }}
              >
                <strong>Check your email</strong>
                <br />
                {response.emailAddress}
                <br />
                for a sign in button
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Divider>
                <Typography
                  sx={{
                    fontWeight: "bold",
                  }}
                >
                  Haven&apos;t received the email?
                </Typography>
              </Divider>
              <Typography>
                Please check your spam folder and allow up to a minute
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  alignSelf: "center",
                }}
              >
                {count > 0 ? (
                  <TypographyLink
                    sx={{
                      color: "grey.500",
                      cursor: "default",
                      textDecoration: "none",
                    }}
                  >
                    Resend Email in {count}s
                  </TypographyLink>
                ) : (
                  <TypographyLink onClick={handleEmailLogin}>
                    Resend Email
                  </TypographyLink>
                )}
              </Box>
            </Box>
          </>
        ) : (
          <Typography>Loading...</Typography>
        )}
      </Box>
    </Box>
  );
}
